import PowerBIEmbedCompliance from "../PowerBIEmbedCompliance";

const CompilancePage = () => {
  return (
    <div style={{ background: "white", minWidth: "100%", minHeight: "100%" }}>
      <PowerBIEmbedCompliance />
    </div>
  );
};

export default CompilancePage;
